module.exports = __webpack_public_path__ + "media/images/client-19-bc654a27dbe253377a573ffe3f4be87e.png";